import React from "react";

export default function Logo({ size = 24, withWordmark = true, className = "" }) {
  return (
    <span className={"flex items-center gap-2 " + className}>
      <img
        src="/logo.jpg"
        alt="ReInVocation"
        width={size}
        height={size}
        className="object-contain"
        style={{ width: size, height: size }}
      />
      {withWordmark && (
        <span className="font-heading font-black tracking-tight">
          ReInVocation
        </span>
      )}
    </span>
  );
}
